import Button from './SwitchToggle.component';
export default Button;